import {
  //
  ADD_ENQUIRY,
  ADD_ENQUIRY_FAILURE,
  ADD_ENQUIRY_SUCCESS,
  //
  DELETE_ENQUIRY,
  DELETE_ENQUIRY_FAILURE,
  DELETE_ENQUIRY_SUCCESS,
  //
  EDIT_ENQUIRY,
  EDIT_ENQUIRY_FAILURE,
  EDIT_ENQUIRY_SUCCESS,
  //
  FETCH_ENQUIRIES,
  FETCH_ENQUIRIES_FAILURE,
  FETCH_ENQUIRIES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  DELETE_ENQUIRY_NOTE,
  DELETE_ENQUIRY_NOTE_FAILURE,
  DELETE_ENQUIRY_NOTE_SUCCESS,
  //
  DELETE_ENQUIRY_REMINDER_NOTE,
  DELETE_ENQUIRY_REMINDER_NOTE_FAILURE,
  DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS,
  //
  OPEN_NOTE_ADD_MODAL,
  CLOSE_NOTE_ADD_MODAL,
  //
  OPEN_REMINDER_ADD_MODAL,
  CLOSE_REMINDER_ADD_MODAL,
  //
  ADD_NOTE,
  ADD_NOTE_SUCCESS,
  ADD_NOTE_FAILURE,
  //
  GET_NOTES,
  GET_NOTES_FAILURE,
  GET_NOTES_SUCCESS,
  //
  ADD_REMINDER,
  ADD_REMINDER_SUCCESS,
  ADD_REMINDER_FAILURE,
  //
  GET_REMINDERS,
  GET_REMINDERS_FAILURE,
  GET_REMINDERS_SUCCESS,
  //
  GET_TIMELINE,
  GET_TIMELINE_SUCCESS,
  GET_TIMELINE_FAILURE,
  //
  TOGGLE_EVENT_MODAL,
  //
  ADD_EVENT,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAILURE,
  //
  GET_STATS,
  GET_STATS_SUCCESS,
  GET_STATS_FAILURE,
  //
  TOGGLE_ADDRESS_MODAL,
  TOGGLE_ATTORNEY_MODAL,
  TOGGLE_ASSIGN_MODAL,
  //
  TOGGLE_SCHEDULE_MODAL,
  TOGGLE_OUTCOME_MODAL,
  TOGGLE_REMINDER_MODAL,
  TOGGLE_CLOSE_MODAL,
  TOGGLE_DOC_MODAL,
  TOGGLE_OTHER_MODAL,
  TOGGLE_EXIST_MODAL,
  //
  SAVE_DOCS,
  SAVE_DOCS_SUCCESS,
  SAVE_DOCS_FAILURE,
  //
  SAVE_OUTCOME,
  SAVE_OUTCOME_SUCCESS,
  SAVE_OUTCOME_FAILURE,
  //
  SAVE_CLOSE,
  SAVE_CLOSE_SUCCESS,
  SAVE_CLOSE_FAILURE,
  //
  SET_VIEW,
  //
  SEARCH_EMAIL,
  SEARCH_EMAIL_SUCCESS,
  SEARCH_EMAIL_FAILURE,
  //
  SEARCH_CONTACT,
  SEARCH_CONTACT_SUCCESS,
  SEARCH_CONTACT_FAILURE,
  //
  EDIT_OUTCOME,
  EDIT_OUTCOME_SUCCESS,
  EDIT_OUTCOME_FAILURE,
  //
  GET_ENQ_CHART,
  GET_ENQ_CHART_SUCCESS,
  GET_ENQ_CHART_FAILURE,
  //
  GET_CL_REPORT,
  GET_CL_REPORT_SUCCESS,
  GET_CL_REPORT_FAILURE,
  //
  GET_AQ_REPORT,
  GET_AQ_REPORT_SUCCESS,
  GET_AQ_REPORT_FAILURE,
  //
  GET_REF_REPORT,
  GET_REF_REPORT_SUCCESS,
  GET_REF_REPORT_FAILURE,
  //
  SET_REPORT,
  //
  GET_TYPE_REPORT,
  GET_TYPE_REPORT_SUCCESS,
  GET_TYPE_REPORT_FAILURE,
  //
  GET_MAP_REPORT,
  GET_MAP_REPORT_SUCCESS,
  GET_MAP_REPORT_FAILURE,
  //
  GET_MY_TASK,
  GET_MY_TASK_SUCCESS,
  GET_MY_TASK_FAILURE,
  //
  SEARCH_USER,
  SEARCH_USER_SUCCESS,
  SEARCH_USER_FAILURE,
  //
  GET_COUNTY,
  GET_COUNTY_SUCCESS,
  GET_COUNTY_FAILURE,
  //
  UPDATE_DONE,
  UPDATE_DONE_SUCCESS,
  UPDATE_DONE_FAILURE,
  //
  SET_DIGITAL_DATA,
  SET_RECOMM_DATA,
  SET_LOCAL_DATA,
  SET_ADVERT_DATA,
} from "./constants";

// List
export const fetchEnquiries = (payload) => ({
  type: FETCH_ENQUIRIES,
  payload,
});
export const fetchEnquiriesSuccess = (payload) => ({
  type: FETCH_ENQUIRIES_SUCCESS,
  payload,
});
export const fetchEnquiriesFailure = (payload) => ({
  type: FETCH_ENQUIRIES_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addEnquiry = (payload) => ({
  type: ADD_ENQUIRY,
  payload,
});
export const addEnquirySuccess = (payload) => ({
  type: ADD_ENQUIRY_SUCCESS,
  payload,
});
export const addEnquiryFailure = (payload) => ({
  type: ADD_ENQUIRY_FAILURE,
  payload,
});
// EDIT
export const editEnquiry = (payload, onEditSuccess) => ({
  type: EDIT_ENQUIRY,
  payload,
  onEditSuccess,
});
export const editEnquirySuccess = (payload) => ({
  type: EDIT_ENQUIRY_SUCCESS,
  payload,
});
export const editEnquiryFailure = (payload) => ({
  type: EDIT_ENQUIRY_FAILURE,
  payload,
});
// DELETE
export const deleteEnquiry = (payload) => ({
  type: DELETE_ENQUIRY,
  payload,
});
export const deleteEnquirySuccess = (payload) => ({
  type: DELETE_ENQUIRY_SUCCESS,
  payload,
});
export const deleteEnquiryFailure = (payload) => ({
  type: DELETE_ENQUIRY_FAILURE,
  payload,
});
// DELETE Enquiry Note
export const deleteEnquiryNote = (payload) => ({
  type: DELETE_ENQUIRY_NOTE,
  payload,
});
export const deleteEnquiryNoteSuccess = (payload) => ({
  type: DELETE_ENQUIRY_NOTE_SUCCESS,
  payload,
});
export const deleteEnquiryNoteFailure = (payload) => ({
  type: DELETE_ENQUIRY_NOTE_FAILURE,
  payload,
});
// DELETE Enquiry Reminder
export const deleteEnquiryReminderNote = (payload) => ({
  type: DELETE_ENQUIRY_REMINDER_NOTE,
  payload,
});
export const deleteEnquiryReminderNoteSuccess = (payload) => ({
  type: DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS,
  payload,
});
export const deleteEnquiryReminderNoteFailure = (payload) => ({
  type: DELETE_ENQUIRY_REMINDER_NOTE_FAILURE,
  payload,
});
//
export const openNoteAddModal = (payload) => ({
  type: OPEN_NOTE_ADD_MODAL,
  payload,
});
export const closeNoteAddModal = (payload) => ({
  type: CLOSE_NOTE_ADD_MODAL,
  payload,
});
//
export const openReminderAddModal = (payload) => ({
  type: OPEN_REMINDER_ADD_MODAL,
  payload,
});
export const closeReminderAddModal = (payload) => ({
  type: CLOSE_REMINDER_ADD_MODAL,
  payload,
});
// ADD ENQUIRY NOTE
export const addEnquiryNote = (payload, onNoteSuccess) => ({
  type: ADD_NOTE,
  payload,
  onNoteSuccess,
});
export const addEnquiryNoteSuccess = (payload) => ({
  type: ADD_NOTE_SUCCESS,
  payload,
});
export const addEnquiryNoteFailure = (payload) => ({
  type: ADD_NOTE_FAILURE,
  payload,
});
// List Note
export const fetchEnquiriesNotes = (payload) => ({
  type: GET_NOTES,
  payload,
});
export const fetchEnquiriesNotesSuccess = (payload) => ({
  type: GET_NOTES_SUCCESS,
  payload,
});
export const fetchEnquiriesNotesFailure = (payload) => ({
  type: GET_NOTES_FAILURE,
  payload,
});
// ADD ENQUIRY REMINDER
export const addEnquiryReminder = (payload, onReminderSuccess) => ({
  type: ADD_REMINDER,
  payload,
  onReminderSuccess,
});
export const addEnquiryReminderSuccess = (payload) => ({
  type: ADD_REMINDER_SUCCESS,
  payload,
});
export const addEnquiryReminderFailure = (payload) => ({
  type: ADD_REMINDER_FAILURE,
  payload,
});
// List Enquiry Reminder
export const fetchEnquiriesReminders = (payload) => ({
  type: GET_REMINDERS,
  payload,
});
export const fetchEnquiriesRemindersSuccess = (payload) => ({
  type: GET_REMINDERS_SUCCESS,
  payload,
});
export const fetchEnquiriesRemindersFailure = (payload) => ({
  type: GET_REMINDERS_FAILURE,
  payload,
});
//
export const getTimeline = (payload) => ({
  type: GET_TIMELINE,
  payload,
});
export const getTimelineSuccess = (payload) => ({
  type: GET_TIMELINE_SUCCESS,
  payload,
});
export const getTimelineFailure = (payload) => ({
  type: GET_TIMELINE_FAILURE,
  payload,
});
//
export const toggleEventModal = (payload) => ({
  type: TOGGLE_EVENT_MODAL,
  payload,
});

//
export const addEvent = (payload) => ({
  type: ADD_EVENT,
  payload,
});
export const addEventSuccess = (payload) => ({
  type: ADD_EVENT_SUCCESS,
  payload,
});
export const addEventFailure = (payload) => ({
  type: ADD_EVENT_FAILURE,
  payload,
});
//
export const getStats = (payload) => ({
  type: GET_STATS,
  payload,
});
export const getStatsSuccess = (payload) => ({
  type: GET_STATS_SUCCESS,
  payload,
});
export const getStatsFailure = (payload) => ({
  type: GET_STATS_FAILURE,
  payload,
});
//

export const toggleAddressModal = (payload) => ({
  type: TOGGLE_ADDRESS_MODAL,
  payload,
});
export const toggleAttorneyModal = (payload) => ({
  type: TOGGLE_ATTORNEY_MODAL,
  payload,
});
export const toggleAssignModal = (payload) => ({
  type: TOGGLE_ASSIGN_MODAL,
  payload,
});

//
export const toggleScheduleModal = (payload) => ({
  type: TOGGLE_SCHEDULE_MODAL,
  payload,
});
export const toggleOutcomeModal = (payload) => ({
  type: TOGGLE_OUTCOME_MODAL,
  payload,
});
export const toggleReminderModal = (payload) => ({
  type: TOGGLE_REMINDER_MODAL,
  payload,
});
export const toggleCloseModal = (payload) => ({
  type: TOGGLE_CLOSE_MODAL,
  payload,
});
export const toggleDocModal = (payload) => ({
  type: TOGGLE_DOC_MODAL,
  payload,
});
export const toggleOtherModal = (payload) => ({
  type: TOGGLE_OTHER_MODAL,
  payload,
});
export const toggleExistModal = (payload) => ({
  type: TOGGLE_EXIST_MODAL,
  payload,
});

//
export const saveDocs = (payload, onSuccess) => ({
  type: SAVE_DOCS,
  payload,
  onSuccess,
});
export const saveDocsSuccess = (payload) => ({
  type: SAVE_DOCS_SUCCESS,
  payload,
});
export const saveDocsFailure = (payload) => ({
  type: SAVE_DOCS_FAILURE,
  payload,
});

//
export const saveOutcome = (payload, onSaveSuccess) => ({
  type: SAVE_OUTCOME,
  payload,
  onSaveSuccess,
});
export const saveOutcomeSuccess = (payload) => ({
  type: SAVE_OUTCOME_SUCCESS,
  payload,
});
export const saveOutcomeFailure = (payload) => ({
  type: SAVE_OUTCOME_FAILURE,
  payload,
});

//
export const saveClose = (payload) => ({
  type: SAVE_CLOSE,
  payload,
});
export const saveCloseSuccess = (payload) => ({
  type: SAVE_CLOSE_SUCCESS,
  payload,
});
export const saveCloseFailure = (payload) => ({
  type: SAVE_CLOSE_FAILURE,
  payload,
});

//
export const setView = (payload) => ({
  type: SET_VIEW,
  payload,
});

//
export const searchEmail = (payload) => ({
  type: SEARCH_EMAIL,
  payload,
});
export const searchEmailSuccess = (payload) => ({
  type: SEARCH_EMAIL_SUCCESS,
  payload,
});
export const searchEmailFailure = (payload) => ({
  type: SEARCH_EMAIL_FAILURE,
  payload,
});

//
export const searchContact = (payload) => ({
  type: SEARCH_CONTACT,
  payload,
});
export const searchContactSuccess = (payload) => ({
  type: SEARCH_CONTACT_SUCCESS,
  payload,
});
export const searchContactFailure = (payload) => ({
  type: SEARCH_CONTACT_FAILURE,
  payload,
});

//
export const editOutcome = (payload, onEditSuccess) => ({
  type: EDIT_OUTCOME,
  payload,
  onEditSuccess,
});
export const editOutcomeSuccess = (payload) => ({
  type: EDIT_OUTCOME_SUCCESS,
  payload,
});
export const editOutcomeFailure = (payload) => ({
  type: EDIT_OUTCOME_FAILURE,
  payload,
});

//
export const getEnqChart = (payload) => ({
  type: GET_ENQ_CHART,
  payload,
});
export const getEnqChartSuccess = (payload) => ({
  type: GET_ENQ_CHART_SUCCESS,
  payload,
});
export const getEnqChartFailure = (payload) => ({
  type: GET_ENQ_CHART_FAILURE,
  payload,
});

//
export const getClReport = (payload) => ({
  type: GET_CL_REPORT,
  payload,
});
export const getClReportSuccess = (payload) => ({
  type: GET_CL_REPORT_SUCCESS,
  payload,
});
export const getClReportFailure = (payload) => ({
  type: GET_CL_REPORT_FAILURE,
  payload,
});

//
export const getAqReport = (payload) => ({
  type: GET_AQ_REPORT,
  payload,
});
export const getAqReportSuccess = (payload) => ({
  type: GET_AQ_REPORT_SUCCESS,
  payload,
});
export const getAqReportFailure = (payload) => ({
  type: GET_AQ_REPORT_FAILURE,
  payload,
});

//
export const getRefReport = (payload) => ({
  type: GET_REF_REPORT,
  payload,
});
export const getRefReportSuccess = (payload) => ({
  type: GET_REF_REPORT_SUCCESS,
  payload,
});
export const getRefReportFailure = (payload) => ({
  type: GET_REF_REPORT_FAILURE,
  payload,
});
export const setReport = (payload) => ({
  type: SET_REPORT,
  payload,
});

//
export const getTypeReport = (payload) => ({
  type: GET_TYPE_REPORT,
  payload,
});
export const getTypeReportSuccess = (payload) => ({
  type: GET_TYPE_REPORT_SUCCESS,
  payload,
});
export const getTypeReportFailure = (payload) => ({
  type: GET_TYPE_REPORT_FAILURE,
  payload,
});

//
export const getMapReport = (payload) => ({
  type: GET_MAP_REPORT,
  payload,
});
export const getMapReportSuccess = (payload) => ({
  type: GET_MAP_REPORT_SUCCESS,
  payload,
});
export const getMapReportFailure = (payload) => ({
  type: GET_MAP_REPORT_FAILURE,
  payload,
});

//
export const getMyTask = (payload) => ({
  type: GET_MY_TASK,
  payload,
});
export const getMyTaskSuccess = (payload) => ({
  type: GET_MY_TASK_SUCCESS,
  payload,
});
export const getMyTaskFailure = (payload) => ({
  type: GET_MY_TASK_FAILURE,
  payload,
});

//
export const searchUser = (payload) => ({
  type: SEARCH_USER,
  payload,
});
export const searchUserSuccess = (payload) => ({
  type: SEARCH_USER_SUCCESS,
  payload,
});
export const searchUserFailure = (payload) => ({
  type: SEARCH_USER_FAILURE,
  payload,
});

//
export const getCounty = (payload) => ({
  type: GET_COUNTY,
  payload,
});
export const getCountySuccess = (payload) => ({
  type: GET_COUNTY_SUCCESS,
  payload,
});
export const getCountyFailure = (payload) => ({
  type: GET_COUNTY_FAILURE,
  payload,
});
//
export const updateDone = (payload, onUpdate) => ({
  type: UPDATE_DONE,
  payload,
  onUpdate,
});
export const updateDoneSuccess = (payload) => ({
  type: UPDATE_DONE_SUCCESS,
  payload,
});
export const updateDoneFailure = (payload) => ({
  type: UPDATE_DONE_FAILURE,
  payload,
});

export const setDigitalData = (payload) => ({
  type: SET_DIGITAL_DATA,
  payload,
});
export const setRecommData = (payload) => ({
  type: SET_RECOMM_DATA,
  payload,
});
export const setLocalData = (payload) => ({
  type: SET_LOCAL_DATA,
  payload,
});
export const setAdvertData = (payload) => ({
  type: SET_ADVERT_DATA,
  payload,
});
